import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { staking } from './reducer';

const initStakingState = {
  exchangeModalOpened: false,
  addFundsModalOpened: false,
  showRewardInfo: false,
  mainStakingWallet: null,
  wallets: [],
};

export const StakingContext = createContext(initStakingState);

export const StakingProvider = ({ children }) => {
  const [state, dispatch] = useReducer(staking?.StakingReducer, initStakingState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in staking?.actions) {
    boundActions[key] = staking.actions[key](dispatch);
  }

  return (
    <StakingContext.Provider value={{ state, ...boundActions }}>{children}</StakingContext.Provider>
  );
};

StakingProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
